import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ThemeProvider } from 'styled-components'

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { BaseApp, theme, Toast, ToastContext, useSetLanguage } from '@reveni-io/reveni-ui'

import { availableLanguages } from '@/common/constants'
import AppContext from '@/common/context/app.context'
import WebsocketActionsProvider from '@/common/context/websocketActions/WebsocketActionsProvider'
import { initSentry } from '@/common/helpers/helpers'
import useBootstrap from '@/common/hooks/useBootstrap/useBootstrap'
import Router from '@/Router/Router'

function App() {
  const [appContext, setAppContext] = useState({})
  const [toastInfo, setToastInfo] = useState({
    show: false,
    message: '',
    type: 'error',
  })
  const { i18n } = useTranslation()
  useSetLanguage(availableLanguages, i18n.language)

  useEffect(() => {
    initSentry()
  }, [])

  useEffect(() => {
    if (toastInfo.show) {
      setTimeout(() => {
        setToastInfo({ ...toastInfo, show: false })
      }, toastInfo.ms || 2500)
    }
  }, [toastInfo, toastInfo.error])

  useBootstrap(setAppContext)

  return (
    <BaseApp>
      <ThemeProvider theme={theme.reveni}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={i18n.language}>
          <ToastContext.Provider value={{ toastInfo, setToastInfo }}>
            <AppContext.Provider value={{ updateContext: setAppContext, info: appContext }}>
              <WebsocketActionsProvider>
                <Router />
                <Toast show={toastInfo.show} type={toastInfo.type} message={toastInfo.message} />
              </WebsocketActionsProvider>
            </AppContext.Provider>
          </ToastContext.Provider>
        </LocalizationProvider>
      </ThemeProvider>
    </BaseApp>
  )
}

export default App
